module.exports = __webpack_public_path__ + "static/media/search.e0f4f30e.svg";